import { render, staticRenderFns } from "./LawCourtList.vue?vue&type=template&id=1334c885&"
import script from "./LawCourtList.vue?vue&type=script&lang=js&"
export * from "./LawCourtList.vue?vue&type=script&lang=js&"
import style0 from "./LawCourtList.vue?vue&type=style&index=0&id=1334c885&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports